import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { red, grey } from '@mui/material/colors'
import ErrorIcon from '@mui/icons-material/Error'
import EmptyIcon from '@mui/icons-material/HelpCenterOutlined'

const ErrorMessage = ({ error, empty, icon, message, onRetry }) => {
  const fontSize = 200

  const errorMessage =
    message ||
    (error
      ? error?.response?.data.message || error?.message || error?.name || 'An error occurred'
      : empty
        ? 'Nothing here'
        : 'Unknown error')

  const ErrorComponent = icon || (empty ? EmptyIcon : ErrorIcon)
  const errorIconColor = empty ? grey[200] : red[200]

  return (
    <Box textAlign='center' justifyContent='center' width='100%'>
      <ErrorComponent style={{ fontSize: fontSize, color: errorIconColor }} />
      {error?.response && (
        <Typography align='center' variant='h2'>
          {error?.response.status}
        </Typography>
      )}
      <Typography align='center' paragraph>
        {errorMessage}
      </Typography>
      {onRetry && (
        <Button onClick={onRetry} variant='contained' color='primary'>
          Retry
        </Button>
      )}
    </Box>
  )
}

export default React.memo(ErrorMessage)
